import router from '@/router'
import asyncRoutes from '@/router/asyncRoutes'
import s from 'storejs'
import store from '@/store'
import { getlang } from '@/lang'
import { Message } from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { utilCookies } from '@/util/cookies'
import getPageTitle from '@/util/get-page-title'
import { currentSession } from 'api/common'
import { getUserInfo } from 'api/login'
import loading from '@/components/loading/loading'

NProgress.configure({ showSpinner: false })
// 路由白名单 不需要登录
export const loginFree = [
  '/login/index',
  '/login',
  '/resetPass',
  '/login/create-company',
  '/login/loginCompany',
  '/login/loginWarning',
  '/register/index',
  '/register/team',
  '/register/success'
]

const login = '/login/index'
const register = '/register/index'
const loginCompany = '/login/loginCompany'

router.beforeEach(async (to, from, next) => {
  const { path } = to
  // changeLanguage(to)
  NProgress.start()
  const status = loginFree.filter(item => item === to.path)[0]
  if (status) loading.open()
  // 等待语言包
  await getlang()
  document.title = getPageTitle(to.meta.title)
  // 获取登录Token
  const token = utilCookies.getToken()
  const companyToken = utilCookies.getCompanyToken()
  const isLogged = token && companyToken
  // 未登录个人
  if (!token && path !== login && path !== register) return next({ path: login })
  // 未登录企业
  if (!companyToken && !loginFree.includes(path)) return next({ path: loginCompany })
  // 默认跳转
  if (isLogged && path === loginCompany) return next({ path: '/' })
  // 获取路由
  if (isLogged && (!store.getters.routes || !store.getters.routes.length)) {
    try {
      await currentSession()
        .then(res => {
          const { data } = res
          store.dispatch('permission/setPermissionList', data.permissions)
          store.dispatch('user/setUserInfo', data.user_info)
          store.commit('user/COMPANY_INFO', data.company_info)
          s.set('currentCompany', data.company_info)
          s.set('userInfo', data.user_info)
        })
        .catch(error => {
          Message.warning('Internal server error')
          utilCookies.removeToken()
          utilCookies.removeCompanyToken()
          return error
        })
      const left_days = store.state.user.company_info.left_days
      // 权限过滤
      let accessRoutes = filterAsyncRoutes(asyncRoutes, store.getters.permissionList)
      accessRoutes = menuFilter(accessRoutes, left_days)
      router.addRoutes(accessRoutes)
      store.dispatch('permission/setRoutes', accessRoutes)
      // 获取公司列表
      const res = await getUserInfo()
      s.set('companyList', res.data.managed)
      s.set('userInfo', res.data.user_info)
      // 过期之后默认跳转企业管理
      if (!left_days) {
        next({ path: '/settings/settings_company_manager' })
      } else {
        next({ ...to, replace: true })
      }
    } catch (error) {
      console.log(error)
      next(`${login}?redirect=${to.path}`)
    }
  }
  next()
})

router.afterEach(() => {
  NProgress.done()
  loading.close()
})

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(permissionList, route) {
  if (route.meta && route.meta.permission) {
    return permissionList.some(item => route.meta.permission.includes(item))
  } else {
    return true
  }
}
// author menu filter
function menuFilter(menu, isExpre) {
  let res = []
  if (!isExpre) {
    menu.forEach(route => {
      if (route.path === '/settings') {
        route.children = [route.children[0]]
        res.push(route)
      }
    })
  } else {
    res = menu
  }
  return res
}
// Url language
// function changeLanguage(to) {
//   const lang = to.query.lang
//   const url = util.ridUrlParam(window.location.href, ['lang'])
//   if (lang && lang !== utilCookies.getLanguage()) utilCookies.setLanguage(lang)
//   if (lang) {
//     window.location.href = url
//     window.location.reload()
//   }
// }
/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, permissionList) {
  const res = []
  routes.forEach(route => {
    const tmp = { ...route }
    if (hasPermission(permissionList, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, permissionList)
      }
      res.push(tmp)
    }
  })
  return res
}
